import { PhosphorTrashButton, PhosphorPencilButton } from "components/Atoms/PhosphorIconButton";
import CultureFlag from "components/Culture/CultureFlag";
import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import InPageEditableFieldWithLabel from "components/MainSectionTemplate/InPageEditableFieldWithLabel";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { OptionalTextAreaDetails } from "components/ValidatedFields/OptionalTextAreaInput";
import React from "react";
import { isNullOrEmptyString } from "utilities";
import ParticipantDebugInfo from "./ParticipantDebugInfo";
import { ButtonText } from "components/Atoms/Button";
import { useContact } from "utilities/api/contactQuery";
import { PhosphorCopy } from "components/Atoms/PhosphorIcon";
import { CopyToClipboardTooltip } from "components/Atoms/CopyToClipboardTooltip";
import { ResendInvitationButton } from "./ResendInvitationButton";

interface Props {
  lifeCycle: server.dto.DocumentLifeCycles
  participant: server.dto.InvoiceParticipant
  onDeleteClicked: () => void
  onEditClicked: () => void
}

const RecipientsRow = (props: Props) => {
  const { participant } = props;

  const lifeCyclesAllowedToEditViewers: server.dto.DocumentLifeCycles[] = ["draft", "review"];
  const lifeCyclesAllowedToRemoveViewers: server.dto.DocumentLifeCycles[] = ["draft", "review", "pending"];

  const canEdit = lifeCyclesAllowedToEditViewers.includes(props.lifeCycle);
  const canRemove = lifeCyclesAllowedToRemoveViewers.includes(props.lifeCycle);

  const contact = useContact(participant.contact);

  return <div className="flex-column gap">
    <div className="flex gap">
      <div>
        <CultureFlag lcid={contact.culture} size="medium" />
      </div>
      <div className="grow1 flex-column gap">
        <div>
          <ContactSidePanel
            trigger={<h4>
              <a>
                {contact.name.fullName}
              </a>
            </h4>}
            contactId={contact.contactId}
          />
          <div>
            {participant.email}
          </div>
        </div>

        <ParticipantDebugInfo participant={props.participant} />

        {props.lifeCycle === "pending" && <div className="flex gap-larger">
          <ResendInvitationButton
            participant={participant}
          />
          <CopyToClipboardTooltip>
            {(copy) => <div className="flex gap-small" onClick={() => copy(participant.landingUrl)}>
              <ButtonText
                label={RESX.Buttons.CopyLink}
                style={{ padding: 0 }}
                onClick={() => copy(participant.landingUrl)}
              />
              <PhosphorCopy />
            </div>}
          </CopyToClipboardTooltip>

        </div>}
      </div>

      {canRemove && <PhosphorTrashButton
        layout="in-square"
        onClick={props.onDeleteClicked} />}
      {canEdit && <PhosphorPencilButton
        layout="in-square"
        onClick={props.onEditClicked} />}
    </div>
    {
      canEdit && <div>
        <CollapsibleSection
          title={RESX.Invitation.resxInvitation}
          collapsible="startClosed"
          uniqueRowId={`invoiceV2-viewer-${participant.invoiceParticipantId}`}
        >
          <div className="main-section-template-grid">
            <InPageEditableFieldWithLabel
              compact={false}
              field={{
                key: "subject",
                label: "Subject",
                isEmpty: isNullOrEmptyString(participant.invitationSubject),
                render: () => <div>{participant.invitationSubject}</div>
              }}
            />

            <InPageEditableFieldWithLabel
              compact={false}
              field={{
                key: "body",
                label: "Body",
                isEmpty: isNullOrEmptyString(participant.invitationBody),
                render: () => <OptionalTextAreaDetails>{participant.invitationBody}</OptionalTextAreaDetails>
              }}
            />
          </div>
        </CollapsibleSection>
      </div>
    }
  </div >;
};

export default RecipientsRow;